// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { dashboardBuilderTemplates16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-dashboard-builder-templates': IconDashboardBuilderTemplates;
    }
}

/**
 * The icon component for the 'dashboardBuilderTemplates' icon
 */
export class IconDashboardBuilderTemplates extends IconSvg {
    public constructor() {
        super(dashboardBuilderTemplates16X16);
    }
}

registerIconSvg('icon-dashboard-builder-templates', IconDashboardBuilderTemplates);
export const iconDashboardBuilderTemplatesTag = 'nimble-icon-dashboard-builder-templates';
